import { withInstall } from '@element-plus/utils'
import UploadV2 from './src/index.vue'

export const ElUploadV2 = withInstall(UploadV2)
export default ElUploadV2
